import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from 'design-system';
import { ChevronDown, Palette } from 'lucide-react';

import { chartPaletteSelection } from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector/const';
import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';

const ApplyPaletteDropdown = () => {
  const { form } = useAppForm();

  return (
    <form.Subscribe selector={s => s.values?.symbols}>
      {symbols => {
        const activeLength = symbols?.active.length ?? 0;

        return (
          <DropdownMenu>
            <DropdownMenuTrigger
              render={
                <Button
                  aria-label='apply-palette-button'
                  disabled={activeLength === 0}
                  variant='secondary'
                />
              }
            >
              <Palette />
              Apply palette
              <ChevronDown />
            </DropdownMenuTrigger>
            <DropdownMenuContent className='w-52'>
              {chartPaletteSelection.map(({ id, name, palette }) => (
                <DropdownMenuItem
                  key={name}
                  className='flex justify-between gap-3 py-2'
                  onClick={() => {
                    form.setFieldValue('colorPalette', id);
                  }}
                >
                  <span>{name}</span>
                  <span
                    aria-hidden='true'
                    className='flex overflow-hidden rounded-sm'
                  >
                    {palette.slice(0, 5).map(color => (
                      <span
                        key={color.hex}
                        className='size-3'
                        style={{ backgroundColor: color.hex }}
                      />
                    ))}
                  </span>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        );
      }}
    </form.Subscribe>
  );
};

export default ApplyPaletteDropdown;
